<template>
  <div class="custom-font-picker form-group">
    <label>{{ label }}</label>
    <div class="form-control d-flex align-items-center">
      <custom-font-picker
        api-key="AIzaSyBunfVG1M012FRUR-J1mqgmMiHEQtXsab0"
        :active-font="value"
        :options="options"
        @change="myFunc"
      />
    </div>
  </div>
</template>

<script>
import CustomFontPicker from "./CustomFontPicker";

export default {
  components: { CustomFontPicker },
  props: {
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: "Open Sans"
    }
  },
  data() {
    return {
      options: {
        name: this.name
      }
    };
  },
  methods: {
    myFunc(font) {
      this.$emit("input", font.family);
    }
  }
};
</script>

<style lang="scss">
.custom-font-picker {
  .form-control {
    padding: 0;
  }

  .font-picker {
    box-shadow: none;
    width: 100%;
    height: 100%;

    .dropdown-button {
      height: 100%;
      background: transparent;
    }

    .search {
      input {
        background: transparent;
        border: none;
        height: 100%;
        width: 100%;
        padding: 0 10px;

        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>
